var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2244 9.22584V6.47146C18.2244 4.91542 18.2244 4.13739 17.8551 3.62979C17.4858 3.12218 16.6508 2.87575 14.9809 2.38288C13.84 2.04615 12.8342 1.64047 12.0307 1.27012C10.9351 0.765172 10.3873 0.512695 9.99988 0.512695C9.61241 0.512695 9.06466 0.765172 7.96908 1.27012C7.16553 1.64047 6.15981 2.04614 5.01888 2.38288C3.34895 2.87575 2.51397 3.12218 2.14468 3.62979C1.77539 4.13739 1.77539 4.91542 1.77539 6.47146V9.22584C1.77539 14.5631 6.40191 17.7653 8.71503 19.0328C9.26982 19.3368 9.54717 19.4888 9.99988 19.4888C10.4526 19.4888 10.7299 19.3368 11.2847 19.0328C13.5978 17.7653 18.2244 14.5631 18.2244 9.22584Z",
    stroke: "#0D0D0D",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4761 11.3296L13.9877 13.8892",
    stroke: "#295EF1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2561 8.94375C12.2561 7.18663 10.8584 5.76221 9.13415 5.76221C7.40995 5.76221 6.01221 7.18663 6.01221 8.94375C6.01221 10.7009 7.40995 12.1253 9.13415 12.1253C10.8584 12.1253 12.2561 10.7009 12.2561 8.94375Z",
    stroke: "#295EF1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudit);
export default __webpack_public_path__ + "static/media/icon-audit.a50daab04747aa11001617431ce89146.svg";
export { ForwardRef as ReactComponent };